import { DVFormGroup } from './../../../../shared/helpers/dynamic-validators/dynamic-validator';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-add-room-type',
  templateUrl: './add-room-type.component.html',
  styleUrls: ['./add-room-type.component.css']
})
export class AddRoomTypeComponent implements OnInit {
  @Input() accommodationForm: DVFormGroup;
  constructor() { }

  ngOnInit() {
  }

}
